// extracted by mini-css-extract-plugin
export default {"eventDescription":"ecoHo","sideBySide":"m3ZS9","descriptionSpacing":"JAGhH"};